import { createTheme } from '@mui/material/styles';
import { theme as themeBase } from '../index';
import { Theme, modeForMUI } from '../../../types';
var lightThemeBase = createTheme(themeBase, {
    palette: {
        mode: modeForMUI[Theme.LIGHT_CLASSIC],
    },
});
export var lightClassicTheme = createTheme(lightThemeBase, {
    components: {
        MuiChip: {
            variants: [
                {
                    props: { variant: 'outlined' },
                    style: {
                        borderWidth: '2px',
                        color: lightThemeBase.palette.text.primary,
                    },
                },
            ],
        },
    },
});
